import { render, staticRenderFns } from "./tax-report.vue?vue&type=template&id=7392c0ec"
import script from "./tax-report.vue?vue&type=script&lang=js"
export * from "./tax-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports